module.exports = __webpack_public_path__ + "img/me_center.ea3d084e.svg";